import { verify } from "./verify";


/**
 * UI関連のユーティリティ
 * */
export module ui {

	/**
	 * ウィンドウサイズ(幅)
	 * */
	const POPUPWINDOW_DEFAULT_WIDTH: number = 662;
	/**
	 * ウィンドウサイズ(高さ)
	 * */
	const POPUPWINDOW_DEFAULT_HEIGHT: number = 520;


	/**
	 * ポップアップウィンドウの表示
	 * @param url		接続先URL
	 * @param name		閲覧コンテキスト
	 * @param width		ウィンドウ幅
	 * @param height	ウィンドウ高さ
	 */
	export function windowOpen(url: string, name: string = "", width: number = undefined, height: number = undefined): void {

		if (!url) return;

		if (verify.isEmpty(name)) {
			name = "popupWindow";
		}
		if (verify.isEmpty(width)) {
			width = POPUPWINDOW_DEFAULT_WIDTH;
		}
		if (verify.isEmpty(height)) {
			height = POPUPWINDOW_DEFAULT_HEIGHT;
		}

		// ウィンドウ表示		
		var features: string = "location=yes, menubar=no, status=no, scrollbars=yes, resizable=yes, toolbar=no";;
		features += ",width=" + width;
		features += ",height=" + height;
		var win = window.open(url, name, features);

		win.focus();

	}

	export function tabOpen(url) {
		var win = window.open(url, "tabWindow", "");
		win.focus();
	}

	/**
	 * 画面遷移
	 * @param action	：次画面名
	 */
	export function postRedirect(action: string) {

		let form = document.createElement('form');
		form.action = action;
		form.method = 'POST';
		$('body').append(form);
		form.submit();
	}

	/**
	 * PCサイト？
	 */
	export function usePcDesign(): boolean {

		let result: boolean;

		const userAgent: string = window.navigator.userAgent.toLowerCase();

		if (userAgent.indexOf("iphone") !== -1) {
			result = false;
		}
		else if (userAgent.indexOf("ipod") !== -1) {
			result = false;
		}
		else if (userAgent.indexOf("ipad") !== -1) {
			result = false;
		}
		else if (userAgent.indexOf("android") !== -1) {
			if (userAgent.indexOf("mobile") !== -1) {
				// Android phone
			}
			else {
				// Android Tablet
			}
			result = false;
		}
		else {
			result = true;
		}

		return result;
	}

	/**
	 * WebViewかどうか？
	 * */
	export function isWebView(): boolean {
		const ua = window.navigator.userAgent.toLowerCase();
		if (ua.indexOf("myphotoboxapp") != -1) {
			return true;
		}
		return false;
	}

	/**
	 * iOSかどうか？
	 * */
	export function isiOS(): boolean {
		const ua = window.navigator.userAgent.toLowerCase();
		if (ua.indexOf("iphone") !== -1) {
			return true;
		}
		else if (ua.indexOf("ipod") !== -1) {
			return true;
		}
		else if (ua.indexOf("ipad") !== -1) {
			return true;
		}
		return false;
	}

	/**
	 * androidかどうか？
	 * */
	export function isAndroid(): boolean {
		const ua = window.navigator.userAgent.toLowerCase();
		if (ua.indexOf("android") !== 1) {
			return true;
		}
		return false;
	}
	/**
	 * 対応アプリかどうか
	 * */
	export function isEnabledAdjustApp(): boolean {
		const ua = window.navigator.userAgent.toLowerCase();
		if (ua.indexOf("ffstd") !== -1) {
			return true;
		}
		// 2024ではffstdのみ
		//if (ua.indexOf("fflet") !== -1) {
		//	return true;
		//}
		//if (ua.indexOf("ffdny") !== -1) {
		//	return true;
		//}
		return false;
    }

	/**
	 * 無効なブラウザ判定
	 */
	export function ngBrowser(): boolean {

		let result: boolean;

		const userAgent: string = window.navigator.userAgent.toLowerCase();

		if (userAgent.indexOf("msie") !== -1) {
			// IE 11 未満
			result = true;
		}
		else if (userAgent.indexOf("trident") !== -1) {
			// IE 11 以上
			result = true;
		}
		else if (userAgent.indexOf("edge") !== -1) {
			// Edge
			result = false;
		}
		else if (userAgent.indexOf("chrome") !== -1) {
			// Chrome
			result = false;
		}
		else if (userAgent.indexOf("safari") !== -1) {
			// Safari
			result = false;
		}
		else if (userAgent.indexOf("firefox") !== -1) {
			// Firefox
			result = false;
		}
		else {
			// 上記以外
			result = true;
		}

		return result;
	}

}